import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
// import classnames from 'classnames';
import { Icon } from '../Icon';
import { Text } from '../Typography';
import { Tooltip } from '~/native-ui/Tooltip';
import { SortableItem, SortableHandle } from '~/native-ui/sortable/Sortable';

import { Menu } from "native-base";
import { HStack, themeTools } from "~/native-ui/native-base";


const factory = () => {
  class MenuItem extends Component {
    static itemName = "MENUITEM"
    static propTypes = {
      orderable: PropTypes.bool,
      caption: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      children: PropTypes.node,
      className: PropTypes.string,
      disabled: PropTypes.bool,
      checkable: PropTypes.bool,
      icon: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
      ]),
      onClick: PropTypes.func,
      onHoverIn: PropTypes.func,
      selected: PropTypes.bool,
      shortcut: PropTypes.string,
      theme: PropTypes.shape({
        caption: PropTypes.string,
        disabled: PropTypes.string,
        icon: PropTypes.string,
        menuItem: PropTypes.string,
        dragIcon: PropTypes.string,
        selected: PropTypes.string,
        shortcut: PropTypes.string,
      }),
    };

    static defaultProps = {
      className: '',
      disabled: false,
      selected: false,
      orderable: false,
    };

    elementRef = createRef();   

    componentDidMount() {
      if (!this.props.onHoverIn) return;
      this.elementRef.current?.addEventListener('mouseover', this.handledonHoverIn);
    }

    componentWillUnmount() {
      this.elementRef.current?.removeEventListener('mouseover', this.handledonHoverIn);
    }


    componentDidUpdate(prevProps) {
      if (prevProps.hovered === this.props.hovered) return;
      const mouseoverEvent = new Event('mouseover');
      const mouseOutEvent = new Event('mouseout');
      this.elementRef.current?.dispatchEvent(this.props.hovered ? mouseoverEvent : mouseOutEvent);
    }


    handledonHoverIn = () => {
      if (!this.props.onHoverIn) return;
      this.props.onHoverIn();
    }

    handleClick = (event) => {
        if (this.props.disabled) { return; }
        this.props.onClick?.(event, this);
    };

    renderDragIcon() {
      if (!this.props.orderable) {
        return null;
      }

      return (
          <SortableHandle>
            <Icon type="drag-indicator" />
          </SortableHandle>
      )
    }

    tooltipProps = {
      maxWidth: "400px",
      defaultIsOpen: false,
    }

    renderItem(tooltip = null) {


      let {
        caption,
        disabled,
        icon,
        iconFamily,
        selected,
        shortcut,
        theme = {},
        orderable,
        onClick,
        checkable,
        children = null,
        onHoverIn,
        iconColor,
        tooltip: _,
        ...others
      } = this.props;


      const Component = checkable ? Menu.ItemOption : Menu.Item

      const menuItemProps = {
        ...others,
        flex: 1,
        isDisabled: disabled,
        onPress: this.handleClick,
        style: disabled ? { cursor: "initial" } : others.style,
        opacity: disabled ? 0.4 : 1,
        bg: disabled ? themeTools.mode("warmGray.200", 'warmGray.800')(this.props) : others.bg,
      }


      if (tooltip) {
        return <Tooltip openOnFocus={false} tooltipProps={this.tooltipProps} tooltip={tooltip} position="right" childProps={menuItemProps}>{this.renderItem()}</Tooltip>
      }

      return (
        <Component {...menuItemProps} ref={this.elementRef}>
            <HStack className="menu-item-wrap" space="2">
              { this.renderDragIcon() }
              { icon && typeof icon === "string" ? <Icon color={iconColor} iconFamily={iconFamily} type={icon} /> : icon}
              { caption ? <Text className={theme.caption}>{caption}</Text> : null }
              { shortcut ? <Text fontSize="sm" className={theme.shortcut}>{shortcut}</Text> : null }
              { children }
            </HStack>
        </Component>
      );
    }

    render() {
      const { orderable, index, tooltip } = this.props
      const item = this.renderItem(tooltip);

      return !orderable
        ? item
        : (
          <SortableItem key={ index } index={ index }>
            { item }
          </SortableItem>
        );
    }
  }

  return MenuItem;
};

const MenuItem = factory();
export { factory as menuItemFactory };
export default MenuItem;
export { MenuItem };
